import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import clsx from 'clsx';
import { makeStyles } from '@material-ui/styles';
import { Typography, Link } from '@material-ui/core';
import { useHistory } from 'react-router-dom';
import { useLanguageSettings } from 'views/Settings';

const useStyles = makeStyles(theme => ({
  root: {
    padding: theme.spacing(3)
  }
}));

const Footer = props => {
  const { className, ...rest } = props;
  const history = useHistory();

  const classes = useStyles();
  const { languageContent, getLanguageContent } = useLanguageSettings();
  const [copyrightFooterContent, setCopyrightFooterContent] = useState(null);

  useEffect(() => {
    if (languageContent) {
      setCopyrightFooterContent(getLanguageContent('copyrightFooter'));
    }
  }, [languageContent]);

  useEffect(() => {
    const allFooters = document.querySelectorAll('.copyrightFooter');
    if (history.location.pathname.includes('schema/design') && allFooters.length === 2) {
      const firstFooter = allFooters[0];
      firstFooter.style.display = 'block';
      firstFooter.classList.add('copyright-fixed-footer');
      const lastFooter = allFooters[1];
      lastFooter.style.display = 'none';
    } else if (allFooters.length === 1) {
      const firstFooter = allFooters[0];
      firstFooter.style.display = 'block';
    }
  }, [history.location.pathname.includes('schema/design')]);

  return (
    <div {...rest} className={clsx(classes.root, className, 'copyrightFooter')}>
      <Typography variant="body1">
        {copyrightFooterContent?.content[0] || `Copyright`} &copy; 2020-{`${new Date().getFullYear()} `}{copyrightFooterContent?.content[1] || 'by'}
        <Link component="a" href="https://agilysys.com" target="_blank">
          {` Agilysys NV, LLC. `}
        </Link>
        {copyrightFooterContent?.content[2] || 'All rights reserved.'} 
      </Typography>
    </div>
  );
};

Footer.propTypes = {
  className: PropTypes.string
};

export default Footer;
